import { axiosMicroservice } from 'src/api/axios';

const modifyUrlMap = {
  braintree: 'braintree_upgrade',
  stripe: 'stripe/modify_subscription',
};

export const modifySubscription = async ({
  newPlanId,
  userId,
  customerId,
  email,
  app,
  paymentSystem,
}: {
  newPlanId: string;
  userId: number | string;
  email: string;
  paymentSystem: 'braintree' | 'stripe';
  customerId?: string;
  app: 'Youth' | 'YouthUS';
}): Promise<any> =>
  await axiosMicroservice.post(`${modifyUrlMap[paymentSystem]}`, {
    user_id: userId,
    new_plan_id: newPlanId,
    email: email,
    app: app,
    customer_id: paymentSystem === 'stripe' ? customerId : undefined,
  });
